import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DiscoveryCard.css';

export default function DiscoveryCard({
  to,
  image,
  imageAlt,
  eyebrow,
  title,
  description,
  meta = [],
  primaryAction,
  secondaryLabel = 'View details',
}) {
  const navigate = useNavigate();
  const open = () => navigate(to);
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  };

  return (
    <article className="p4r-discovery-card" role="link" tabIndex={0} onClick={open} onKeyDown={onKeyDown}>
      <div className="p4r-discovery-media">
        {image ? <img src={image} alt={imageAlt || title} loading="lazy" /> : <div className="p4r-discovery-placeholder" aria-hidden="true">4</div>}
        <span className="p4r-discovery-eyebrow">{eyebrow}</span>
      </div>
      <div className="p4r-discovery-copy">
        <h3>{title}</h3>
        {description && <p>{description}</p>}
        <div className="p4r-discovery-meta">
          {meta.filter(Boolean).map((item, index) => <span key={`${item}-${index}`}>{item}</span>)}
        </div>
      </div>
      <div className="p4r-discovery-actions">
        <button type="button" className="p4r-discovery-secondary" onClick={(event) => { event.stopPropagation(); open(); }}>{secondaryLabel}</button>
        {primaryAction && (
          <button
            type="button"
            className="p4r-discovery-primary"
            disabled={primaryAction.disabled}
            onClick={(event) => { event.stopPropagation(); primaryAction.onClick(); }}
          >
            {primaryAction.label}
          </button>
        )}
      </div>
    </article>
  );
}
